const brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

export const moeda = (v) => brl.format(Number(v ?? 0))
export const pct = (v, casas = 2) => `${Number(v ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: 4 })}%`
export const competenciaAtual = () => new Date().toISOString().slice(0, 7)
